/** races the input promise against a timeout */
export function promiseTimeout<T>(
  promise: Promise<T>,
  timeout?: number,
  reason?: string,
) {
  return Promise.race([
    promise,
    new Promise<T>((res, reject) => {
      setTimeout(
        () => reject(new Error(`[ads:timeout] ${reason} @${timeout}ms`)),
        timeout,
      );
    }),
  ]);
}

/** resolving version of promiseTimeout */
export function promiseTimeoutOk<T>(promise: Promise<T>, timeout?: number) {
  return promiseTimeout(promise, timeout).catch();
}
